import axios from 'axios'

class UsuarioApiClient {
	async buscarLogado(produtoId) {
		return await axios.get(`/hal/usuario/sessao?produtoId=${produtoId}`)
	}

	async editar(payload) {
		return await axios.post('/hal/editarUsuario', payload)
	}

	async buscarInformacoes() {
		return await axios.get('/hal/auth/usuario/info')
	}

	async atualizarSessao(idDominio) {
		const tipoDominio = idDominio ? 'ESTRUTURA_ORGANIZACIONAL' : 'DEFAULT'
		await axios.put(
			`/hal/usuario/sessao/atualizarSessao?dominioTipoCliente=${tipoDominio}&dominioIdCliente=${idDominio}`,
		)
	}
}

export default new UsuarioApiClient()
